import React, { Component } from "react";
import { Redirect } from "react-router";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBIcon
} from "mdbreact";
import axios from "axios";
import API_URL from "../config";
import fondo4 from "./Fondo4.jpg";
import boletapago1 from "./Boletapago1.png";
import declaracionJurada from "./DeclaracionJurada.png";
import contrasenaImg from "./contrasena.png";

class Dashboard extends Component {
  state = {
    redirigir: "",
    declaracionesPendientes: [],
    cargandoPendientes: true
  };

  getDatos() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) {
      try { datos = JSON.parse(sessionStorage.getItem("datos")); } catch (e) { datos = null; }
    }
    return datos;
  }

  componentDidMount() {
    var datos = this.getDatos();
    if (datos) sessionStorage.setItem("datos", JSON.stringify(datos));
    var dni = datos && datos[0] ? datos[0].trabajador : null;
    if (!dni) { this.setState({ cargandoPendientes: false }); return; }
    axios.post(API_URL + "/trabajador/declaracionespendientes/", { dni: dni })
      .then(function (r) {
        this.setState({ declaracionesPendientes: r.data || [], cargandoPendientes: false });
      }.bind(this))
      .catch(function () {
        this.setState({ cargandoPendientes: false });
      }.bind(this));
  }

  render() {
    var datos = this.getDatos();
    if (!datos) return <Redirect to="/" />;
    if (this.state.redirigir) {
      return <Redirect push={false} to={{ pathname: this.state.redirigir, state: { datos: datos } }} />;
    }

    var porFirmar = this.state.declaracionesPendientes.filter(function(d) { return !d.firmado; });
    var firmadas  = this.state.declaracionesPendientes.filter(function(d) { return d.firmado; });
    var tienePendientes = porFirmar.length > 0;
    var tieneFirmadas   = firmadas.length > 0;

    var opciones = [
      {
        icon: "file-invoice-dollar",
        titulo: "Boletas de Pago",
        descripcion: "Consulte y descargue sus boletas de pago de los últimos 6 periodos.",
        color: "#7A1622",
        bgImage: boletapago1,
        ruta: "/boletas-pago",
        mostrar: true,
        pendiente: false,
        firmado: false
      },
      {
        icon: "file-signature",
        titulo: "Declaraciones Juradas",
        descripcion: tienePendientes
          ? "Tiene " + porFirmar.length + " declaración" + (porFirmar.length > 1 ? "es" : "") + " pendiente" + (porFirmar.length > 1 ? "s" : "") + " de firma. Ingrese para revisar y firmar."
          : tieneFirmadas
            ? "Su declaración jurada ha sido firmada correctamente. Puede ingresar para descargarla."
            : "Presente su Declaración Jurada de forma digital.",
        color: tieneFirmadas && !tienePendientes ? "#1B5E20" : "#1B5E20",
        bgImage: declaracionJurada,
        ruta: "/declaraciones-juradas",
        mostrar: tienePendientes || tieneFirmadas,
        pendiente: tienePendientes,
        firmado: tieneFirmadas && !tienePendientes
      },
      {
        icon: "user-cog",
        titulo: "Gestión de Cuenta",
        descripcion: "Administre su contraseña de acceso (creación y modificación).",
        color: "#1a5276",
        bgImage: contrasenaImg,
        ruta: "/cambiar-contrasena",
        mostrar: true,
        pendiente: false
      }
    ];

    var opcionesFiltradas = opciones.filter(function (op) { return op.mostrar; });

    return (
      <div style={{ position: "relative", minHeight: "calc(100vh - 4rem)" }}>
        <style>{`
          @keyframes pulso {
            0%   { box-shadow: 0 0 0 0 rgba(230,81,0,0.7); }
            70%  { box-shadow: 0 0 0 12px rgba(230,81,0,0); }
            100% { box-shadow: 0 0 0 0 rgba(230,81,0,0); }
          }
          @keyframes pulsoBadge {
            0%, 100% { opacity: 1; }
            50%       { opacity: 0.6; }
          }
          .card-pendiente {
            animation: pulso 1.8s ease-in-out infinite;
          }
        `}</style>

        <div style={{
          position: "fixed", top: "4rem", left: 0,
          width: "100%", height: "calc(100vh - 4rem)",
          backgroundImage: `url(${fondo4})`,
          backgroundSize: "cover", backgroundPosition: "center", opacity: 0.1
        }} />

        <MDBContainer className="mt-5 pt-4" style={{ position: "relative", zIndex: 1 }}>
          <div className="text-center mb-5">
            <h4 className="font-weight-bold" style={{ color: "#7A1622" }}>
              <MDBIcon icon="th-large" className="mr-2" />Panel Principal
            </h4>
            <p className="text-muted" style={{ fontSize: "0.95rem" }}>
              Seleccione una opción para continuar
            </p>
          </div>

          <MDBRow center>
            {opcionesFiltradas.map(function (op, i) {
              return (
                <MDBCol md="4" className="mb-4" key={i}>
                  <MDBCard
                    className={"h-100" + (op.pendiente ? " card-pendiente" : "")}
                    style={{
                      border: op.pendiente ? "2px solid #E65100" : "2px solid " + op.color + "33",
                      borderRadius: "16px",
                      boxShadow: op.pendiente ? "0 4px 24px rgba(230,81,0,0.25)" : "0 4px 20px rgba(0,0,0,0.08)",
                      cursor: "pointer",
                      transition: "transform 0.2s, box-shadow 0.2s, border-color 0.2s",
                      overflow: "hidden",
                      position: "relative"
                    }}
                    onMouseEnter={function (e) {
                      e.currentTarget.style.transform = "translateY(-6px)";
                      e.currentTarget.style.boxShadow = "0 8px 30px " + op.color + "40";
                      if (!op.pendiente) e.currentTarget.style.borderColor = op.color;
                    }}
                    onMouseLeave={function (e) {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = op.pendiente ? "0 4px 24px rgba(230,81,0,0.25)" : "0 4px 20px rgba(0,0,0,0.08)";
                      if (!op.pendiente) e.currentTarget.style.borderColor = op.color + "33";
                    }}
                    onClick={function () { this.setState({ redirigir: op.ruta }); }.bind(this)}
                  >
                    {/* Badge estado declaración */}
                    {op.pendiente && (
                      <div style={{
                        position: "absolute", top: "12px", right: "12px", zIndex: 10,
                        background: "linear-gradient(135deg, #E65100, #FF6D00)",
                        color: "#fff", borderRadius: "20px", padding: "5px 14px",
                        fontSize: "0.72rem", fontWeight: "800", letterSpacing: "0.03em",
                        boxShadow: "0 2px 8px rgba(230,81,0,0.5)",
                        animation: "pulsoBadge 1.8s ease-in-out infinite",
                        display: "flex", alignItems: "center", gap: "5px"
                      }}>
                        <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: "#fff", display: "inline-block", flexShrink: 0 }}></span>
                        PENDIENTE DE FIRMAR
                      </div>
                    )}
                    {op.firmado && (
                      <div style={{
                        position: "absolute", top: "12px", right: "12px", zIndex: 10,
                        background: "linear-gradient(135deg, #2E7D32, #43A047)",
                        color: "#fff", borderRadius: "20px", padding: "5px 14px",
                        fontSize: "0.72rem", fontWeight: "800", letterSpacing: "0.03em",
                        boxShadow: "0 2px 8px rgba(46,125,50,0.5)",
                        display: "flex", alignItems: "center", gap: "5px"
                      }}>
                        <MDBIcon icon="check-circle" style={{ fontSize: "0.7rem" }} />
                        DECLARACION FIRMADA
                      </div>
                    )}

                    <div style={{
                      background: op.bgImage
                        ? `url(${op.bgImage}) center/contain no-repeat ${op.color}11`
                        : `linear-gradient(135deg, ${op.color}, ${op.color}dd)`,
                      height: "180px", position: "relative"
                    }} />

                    <div style={{ position: "relative", textAlign: "center" }}>
                      <div
                        className="mx-auto d-flex align-items-center justify-content-center"
                        style={{
                          width: "70px", height: "70px", borderRadius: "50%",
                          backgroundColor: op.color,
                          border: "4px solid #fff",
                          boxShadow: op.pendiente ? "0 3px 14px rgba(230,81,0,0.5)" : "0 3px 10px rgba(0,0,0,0.15)",
                          position: "absolute", top: "-35px", left: "50%", transform: "translateX(-50%)"
                        }}
                      >
                        <MDBIcon icon={op.icon} size="2x" style={{ color: "#fff" }} />
                      </div>
                    </div>

                    <MDBCardBody className="text-center px-4" style={{ paddingTop: "50px", paddingBottom: "20px" }}>
                      <h5 className="font-weight-bold mb-2" style={{ color: op.color }}>{op.titulo}</h5>
                      <p className="text-muted mb-3" style={{ fontSize: "0.88rem" }}>{op.descripcion}</p>
                      {op.pendiente ? (
                        <span style={{
                          background: "linear-gradient(135deg, #E65100, #FF6D00)",
                          color: "#fff", borderRadius: "20px", padding: "6px 20px",
                          fontWeight: "700", fontSize: "0.85rem",
                          display: "inline-flex", alignItems: "center", gap: "6px"
                        }}>
                          <MDBIcon icon="pen-nib" />Firmar ahora
                        </span>
                      ) : op.firmado ? (
                        <span style={{
                          background: "linear-gradient(135deg, #2E7D32, #43A047)",
                          color: "#fff", borderRadius: "20px", padding: "6px 20px",
                          fontWeight: "700", fontSize: "0.85rem",
                          display: "inline-flex", alignItems: "center", gap: "6px"
                        }}>
                          <MDBIcon icon="check-circle" className="mr-1" />Declaracion firmada con exito
                        </span>
                      ) : (
                        <span style={{ color: op.color, fontWeight: "600", fontSize: "0.9rem" }}>
                          Ingresar <MDBIcon icon="arrow-right" className="ml-1" />
                        </span>
                      )}
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
              );
            }.bind(this))}
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

export default Dashboard;
